'use strict';

var BaseLayer = require('./base/BaseLayer');

var OverlayLayer = BaseLayer.extend({

  _defaultStyleOptions: null,

  /*
   * All functions declared to conform to the interface, but purposely empty
   * since these layers don't have styles or user insteraction
   */

  setStyle: function () {
    return;
  },

  _getPopupLatLng: function () {
    return;
  },

  _getPopupOptions: function () {
    return;
  },

  /**
   * Set leafletLayer style to highlighted
   */
  _setStateStyleToActive: function () {
    return;
  },

  /**
   * Set leafletLayer style to its default
   */
  _setStateStyleToDefault: function () {
    return;
  },

  /**
   * Set leafletLayer style to dimmed
   */
  _setStateStyleToDim: function () {
    return;
  },
});

module.exports = OverlayLayer;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/OverlayLayer.js